import { RootState } from "store/types";

export const selectUserPosts = (state: RootState) => state.userPosts.data
